// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { black, gray01, primary } from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';
import {
  spacing,
  fontSize,
  fontWeight,
  mediaMax,
} from 'presentations/views/styles';
import Menu from 'presentations/views/components/atoms/Menu';
import { SyntheticEvent } from 'react';
import { ViewerItem } from 'presentations/api/schema/user';
import { Role } from 'domains/models/team_user/role';
import Switch from 'presentations/views/components/atoms/Switch';

interface Props {
  onCloseMenu?: (e: SyntheticEvent<HTMLButtonElement>) => void;
  onSelectMenu?: (selectedIndex: number) => void;
  onClickShowProfile?: () => void;
  anchor?: HTMLElement | null;
  viewer: ViewerItem;
  isMobileApp?: boolean | null;
  teamUrl: string;
  userUrl: string;
  isShowProfile: boolean | null;
}

export enum EventTypeShareOptionIndex {
  profile = 0,
  divider4 = 1,
  onetimeLink = 2,
  divider1 = 3,
  addToWebsite = 4,
  divider2 = 5,
  export = 6,
  divider3 = 7,
  share = 8,
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const options: any[] = [];
  options.push(
    <MenuListItem>
      <MenuListItemContent>
        <MenuListItemIcon name="card-account-details-outline" />
        <MenuListItemTitle>
          <MenuListItemTitleLeft>{t('Show on Profile')}</MenuListItemTitleLeft>
          <MenuListItemTitleRight>
            <Switch
              isDisabled={props.isShowProfile === null}
              isChecked={props.isShowProfile ?? false}
              onChange={props.onClickShowProfile}
            />
          </MenuListItemTitleRight>
        </MenuListItemTitle>
      </MenuListItemContent>
      <MenuListItemDescription>
        <div
          dangerouslySetInnerHTML={{
            __html: t(
              'Show on Profile desc',
              {
                teamProfile: `<a href="${props.teamUrl}" target="_blank">${t(
                  'Team Profile',
                )}</a>`,
                userProfile: `<a href="${props.userUrl}" target="_blank">${t(
                  'User Profile',
                )}</a>`,
              },
              true,
            ),
          }}
        />
      </MenuListItemDescription>
    </MenuListItem>,
  );
  options.push({ isDivider: true });
  options.push(
    <MenuListItem>
      <MenuListItemContent>
        <MenuListItemIcon name="timer-outline" />
        <MenuListItemTitle>{t('One-time Link')}</MenuListItemTitle>
      </MenuListItemContent>
      <MenuListItemDescription>
        {t('One-time Link desc')}
      </MenuListItemDescription>
    </MenuListItem>,
  );
  options.push({ isDivider: true });
  options.push(
    <MenuListItem>
      <MenuListItemContent>
        <MenuListItemIcon name="code-tags" />
        <MenuListItemTitle>{t('Add to Website')}</MenuListItemTitle>
      </MenuListItemContent>
      <MenuListItemDescription>
        {t('Add to Website desc')}
      </MenuListItemDescription>
    </MenuListItem>,
  );

  if (props.viewer.role < Role.Restricted) {
    options.push({ isDivider: true });
    options.push(
      <MenuListItem>
        <MenuListItemContent>
          <MenuListItemIcon name="download" />
          <MenuListItemTitle>{t('Export')}</MenuListItemTitle>
        </MenuListItemContent>
        <MenuListItemDescription>{t('Export desc')}</MenuListItemDescription>
      </MenuListItem>,
    );
  }

  if (props.isMobileApp) {
    options.push({ isDivider: true });
    options.push(
      <MenuListItem>
        <MenuListItemContent>
          <MenuListItemIcon name="export-variant" />
          <MenuListItemTitle>{t('Share Menu')}</MenuListItemTitle>
        </MenuListItemContent>
        <MenuListItemDescription>
          {t('Share Menu desc')}
        </MenuListItemDescription>
      </MenuListItem>,
    );
  }
  return (
    <StyledMenu
      onClose={props.onCloseMenu}
      onSelect={props.onSelectMenu}
      anchor={props.anchor}
      options={options}
    />
  );
}

const StyledMenu = styled(Menu)`
  .MuiMenuItem-root {
    padding-top: ${spacing(8)};
    padding-bottom: ${spacing(8)};
  }
`;
const MenuListItem = styled.div<{
  disabled?: boolean;
}>`
  max-width: 352px;
  :hover {
    color: ${primary};
  }
  ${(props) => css`
    opacity: ${props.disabled ? 0.5 : 1};
    :hover {
      color: ${props.disabled ? black(props) : primary(props)};
    }
  `};
`;
const MenuListItemContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing(8)};
`;
const MenuListItemIcon = styled(Icon)`
  color: ${primary};
  margin-right: ${spacing(4)};
  width: 20px !important;
`;
const MenuListItemTitle = styled.div`
  font-size: ${fontSize(16)};
  font-weight: ${fontWeight('bold')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  ${mediaMax.tablet} {
    font-size: ${fontSize(14)};
  }
`;
const MenuListItemTitleLeft = styled.div`
  display: flex;
  justify-content: flex-start;
`;
const MenuListItemTitleRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const MenuListItemDescription = styled.div`
  font-size: ${fontSize(13)};
  color: ${gray01};
  white-space: normal;
`;

const FormPaidIconContainer = styled.div`
  margin-left: ${spacing(4)};
  font-weight: ${fontWeight('bold')};
`;
